/**
 * File: HomeNavigation.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v2.0.2
 * Created: 2025-10-30
 * Last Updated: 2026-06-23
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { useNavigate } from "react-router-dom";

// Local project files
import { TextButton } from "../ui/Buttons";
import { routes } from "../../constants/routes";
import * as schemas from "../../schemas/schemas";
import DropDown from "../layout/DropDown";

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function HomeNavigation() {
    const navigate = useNavigate();

    const redirectSignInPage = () => {
        navigate(routes.public.auth.signIn.abs);
    };

    return (
        <>
            <nav className="home-navigation">
                <DropDown props={schemas.productsDropDown} />
                <DropDown props={schemas.serviceDropDown} />
            </nav>
            <nav className="home-navigation">
                <TextButton
                    text={"Sign-In"}
                    onClick={redirectSignInPage}
                ></TextButton>
            </nav>
        </>
    );
}

export default HomeNavigation;
